const palette = {
  light: {
    primary: {
      main: "#7E16FF",
      dark: "#5F00D9",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#616161",
      dark: "#424242",
    },
    success: { main: "#2E7D32" },
    error: { main: "#D32F2F" },
    text: { secondary: "rgba(0, 0, 0, 0.6)" },
    background: {
      default: "#F5F5F5",
      paper: "#FAFAFA",
      chat: "#FAF9FC",
    },
    action: { selected: "rgba(0, 0, 0, 0.08)" },
    cards: { background: "#FFF" },
    appBar: { background: "#000000" },
    scrollbar: { thumb: "rgba(0,0,0,.1)" },
    userMessage: { main: "#EDE2FF" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#EEEEEE" },
    queue: { fallback: "#7C7C7C" },
  },
  dark: {
    primary: {
      main: "#A66BFF",
      dark: "#7E16FF",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#BDBDBD",
      dark: "#9E9E9E",
    },
    success: { main: "#66BB6A" },
    error: { main: "#F44336" },
    background: {
      default: "#242424",
      paper: "#1E1E1E",
      chat: "#121212",
    },
    action: { selected: "#383838" },
    cards: { background: "#2C2C2C" },
    appBar: { background: "#000000" },
    scrollbar: { thumb: "hsla(0,0%,100%,.16)" },
    userMessage: { main: "#3A2470" },
    contactMessage: { main: "#2C2C2C" },
    timestamp: { background: "#242424" },
    queue: { fallback: "#7C7C7C" },
  },
};

export default palette;
